export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-flashlight-fill text-background-50 text-lg"></i>
              </span>
              <span className="font-heading font-bold text-xl text-background-50">五一黑料网</span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed mb-4">
              深度挖掘瓜田爆料、黑料内幕及吃瓜事件，实时曝光最新黑料视频与每日吃瓜合集。280万+日活用户信赖的娱乐资讯平台。
            </p>
          </div>

          <div>
            <h4 className="font-bold text-sm text-background-50 mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2.5">
              {[
                { label: '热门话题', href: '#topics' },
                { label: '实时快讯', href: '#updates' },
                { label: '爆款瓜文', href: '#cards' },
                { label: '热度榜单', href: '#ranking' },
                { label: '黑料视频', href: '#media' },
              ].map((item) => (
                <li key={item.href}>
                  <button
                    onClick={() => scrollTo(item.href)}
                    className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-sm text-background-50 mb-4">关于我们</h4>
            <ul className="flex flex-col gap-2.5">
              {[
                { label: '平台介绍', href: '#about' },
                { label: '常见问题', href: '#faq' },
                { label: '联系我们', href: '#contact' },
                { label: '专题索引', href: '#index' },
                { label: '下载APP', href: '#app' },
              ].map((item) => (
                <li key={item.href}>
                  <button
                    onClick={() => scrollTo(item.href)}
                    className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-sm text-background-50 mb-4">合作伙伴</h4>
            <p className="text-foreground-500 text-sm leading-relaxed">
              诚邀优质合作伙伴加入，共同打造最具影响力的娱乐资讯生态。
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; 2024-2026 五一黑料网 版权所有 | 内容仅供娱乐参考，请理性看待
          </p>
          <div className="flex items-center gap-4">
            <button
              onClick={() => scrollTo('#contact')}
              className="text-foreground-500 hover:text-background-50 text-xs transition-colors cursor-pointer"
            >
              投稿爆料
            </button>
            <button
              onClick={() => scrollTo('#faq')}
              className="text-foreground-500 hover:text-background-50 text-xs transition-colors cursor-pointer"
            >
              常见问题
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}